var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMakers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2007 12.6188L12.6144 12.3738C13.4718 11.866 14 10.9276 14 9.91209V6.08799C14 5.07244 13.4718 4.13403 12.6144 3.62626L9.38564 1.71421C8.5282 1.20643 7.4718 1.20643 6.61436 1.71421L3.38564 3.62626C2.5282 4.13403 2 5.07244 2 6.08799V9.91209C2 10.9276 2.5282 11.866 3.38564 12.3738L3.79931 12.6188M12.2007 12.6188L9.38564 14.2859C8.5282 14.7937 7.4718 14.7937 6.61436 14.2859L3.79931 12.6188M12.2007 12.6188C11.3621 11.1322 9.79491 10.132 7.99999 10.132C6.20508 10.132 4.63791 11.1322 3.79931 12.6188",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(1 0 0 -1 8 6)",
    stroke: "#818181",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakers);
export default __webpack_public_path__ + "static/media/makers.cd9d9af73d1f11a08a8e61fc8a737f25.svg";
export { ForwardRef as ReactComponent };